export function getIsSearchValueIncludes(searchValue: string, label: string): boolean {
  return !searchValue || new RegExp(searchValue, 'i').test(label);
}
